import { useSearchParams } from "react-router"
import { useProductAudit } from "../../../api/productsApi"
import { AuditTrail } from "../../shared/AuditTrail"

export function ProductAuditSection() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")

  const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
    useProductAudit(id, { limit: 20 })

  const events = data?.pages.flatMap((p) => p.items) ?? []

  return (
    <AuditTrail
      events={events}
      isLoading={isLoading}
      hasMore={!!hasNextPage}
      isFetchingMore={isFetchingNextPage}
      onLoadMore={fetchNextPage}
    />
  )
}
